export const AllRegions = ['ASIAPAC', 'EA', 'EUCAN', 'LATAM', 'MEA', 'US'];
